import { ALL_COUNTRIES } from '../lookups'
import SearchSelect from './SearchSelect'
import { fill, COMPONENTS_COUNTRY_PICKER_TEXTS as T } from '../../shared/texts'

// THE country field of the backoffice (operator, 2026-10-23: „alle Länder dürfen nur über die Liste
// ausgewählt werden"): all countries, searchable by German name or code, stored as the ISO code.
// The server checks every one of them against the same list (shared/countries.ts → checkedCountry).
// ⚠️ A stored value the list does not know (an older free-text entry) is shown as
// „… (unbekannt)" and KEPT — opening the form must not clear it silently; saving it is refused by
// the server until another entry is picked.

interface Country { code: string, name: string }

const search = (q: string): Country[] => {
    const n = q.toLocaleLowerCase('de')
    if (!n) return ALL_COUNTRIES
    return ALL_COUNTRIES.filter((c) => c.name.toLocaleLowerCase('de').includes(n) || c.code.toLowerCase() === n)
}

const resolve = (code: string): Country =>
    ALL_COUNTRIES.find((c) => c.code === code) ?? { code, name: fill(T.unknown, { code }) }

export default function CountryPicker({ value, onChange, name }: { value: string, onChange: (code: string) => void, name?: string }) {
    return (
        <SearchSelect<Country>
            value={value}
            onChange={onChange}
            search={search}
            resolve={resolve}
            keyOf={(c) => c.code}
            labelOf={(c) => (ALL_COUNTRIES.includes(c) ? `${c.name} (${c.code})` : c.name)}
            placeholder={T.notSet}
            clearLabel={T.notSet}
            name={name}
        />
    )
}
